import { useMutation } from "@tanstack/react-query";
import { api } from "../../utils/api";
import { API_ROUTES } from "../../routes/apiRoutes";

export const updateContractor = async (data) => {
  const response = await api.put(API_ROUTES.CONTRACTOR_PROFILE, data);
  return response.data;
};

export const useContractorUpdateMutation = () => {
  return useMutation({
    mutationKey: ["updateContractor"],
    mutationFn: (data) => updateContractor(data),
  });
};
